import AbstractMapper from '@core/utils/mappers/AbstractMapper';
import { ISpecialTicketItemDto } from '@core/mappers/tickets/dtos/ISubmittingTicketDto';
import SpecialSelection from '@core/models/betSlip/SpecialSelection';

export default class BetSlipItemMapper extends AbstractMapper<any, ISpecialTicketItemDto> {

    createTargetObject(selection: SpecialSelection) {
        const odd = selection.getOdd();
        console.log('Special Selection >> ', selection, odd.code);

        const dto: ISpecialTicketItemDto = {
            // OBA fields start
            // Event code missing on special event ???
            eventCode: selection.event.sportId,
            oddCode: `${odd.code}`,
            oddId: odd.id,
            eventId: `S${selection.event.id}`,
            eventName: selection.event.fullName,
            marketCode: odd.marketCode,
            marketId: odd.eventId,
            marketName: `${odd.marketName}, ${odd.description}`,
            // OBA fields end
            oddTypeId: odd.id,
            sbValue: selection.getOddSpecialBetValue(),
            matchId: selection.eventId,
            value: this.prettyDecimal(selection.getOddValue()!),
            matchDate: selection.getEventDate().toDateString(),
            matchDateUtc: selection.getEventDate().toUTCString(),
            oddDescription: selection.getOddDescription(),
            oddFullName: odd.name, // TODO check
            betGroupId: selection.getMarketId()!,
            fix: selection.isFixed,
            selected: true,
            betRadarId: '', // TODO
            prefix: odd.prefix,
            type: selection.type,
            rules: odd.rules,
            oddName: odd.name!,
            matchName: `${odd.marketName} (${odd.description} - ${selection.getEventFullName()})`
        };
        return dto;
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--12!./src/core/mappers/tickets/SpecialSelectionMapper.ts